import DevisForm from "./DevisForm";

const avantages = [
  {
    icon: "ri-stethoscope-line",
    text: "Diagnostic + déplacement GRATUITS",
  },
  {
    icon: "ri-box-3-line",
    text: "Pièce comprise dans le prix",
  },
  {
    icon: "ri-file-list-3-line",
    text: "Devis ferme avant intervention",
  },
  {
    icon: "ri-shield-check-line",
    text: "Toutes marques",
  },
  {
    icon: "ri-time-line",
    text: "Intervention sous 24h",
  },
];

export default function Formulaire() {
  return (
    <section id="devis" className="bg-brand-light py-14 md:py-20">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-stretch min-w-0">
          {/* Panneau gauche — valorisation */}
          <div className="bg-brand-blue rounded-2xl p-6 md:p-8 text-white flex flex-col">
            <h2 className="text-xl md:text-2xl font-bold mb-6">
              Ce qui est compris dans nos tarifs
            </h2>
            <div className="space-y-5 flex-1">
              {avantages.map((a) => (
                <div key={a.text} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center shrink-0 rounded-full bg-brand-cyan/20">
                    <i className={`${a.icon} text-brand-cyan text-sm`}></i>
                  </div>
                  <p className="text-white/90 text-sm leading-relaxed pt-1">{a.text}</p>
                </div>
              ))}
            </div>
            <a
              href="tel:0374473240"
              className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-6 py-4 rounded-full font-semibold text-base hover:bg-brand-cyan/90 transition-colors whitespace-nowrap mt-6"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>

          {/* Formulaire droite */}
          <DevisForm />
        </div>
      </div>
    </section>
  );
}